












import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class GroupItem extends Vue {
  @Prop({default: 0})
  private showIdx!: number;
  @Prop({default: 0})
  private index!: number;
  @Prop()
  private group!: any;
  private tempGroupName: string = '';
  private editFlg = false;
  private clickTimeOut: any;
  private clickGroup(idx: number) {
    if (idx !== this.showIdx) {
      this.$emit('editShowIdx', idx);
    }
  }
  private dblclickGroup() {
    this.tempGroupName = this.group.name || this.$t('MEMBER_GROUP_DETAIL_NEW_GROUP_NAME');
    this.editFlg = true;
    let _this = this;
    this.$nextTick(() => {
      (_this.$refs.tempGroupName as any).focus();
    });
  }
  private setGroupName() {
    this.group.name = this.tempGroupName;
    this.editFlg = false;
    this.$emit('changeDetailName', {name: this.group.name, type: 'list'});
  }
}
